import {asset} from 'imba';
import url from './L.svg';

export default /* @__PURE__ */ asset({
	url: url,
	type: 'svg',
	meta: {"attributes":{"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"},"flags":[],"content":"\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 12C15 10.3431 16.3431 9 18 9C19.6569 9 21 10.3431 21 12L21 33H30C31.6569 33 33 34.3431 33 36C33 37.6569 31.6569 39 30 39H18C16.3431 39 15 37.6569 15 36L15 12ZM18 11C17.4477 11 17 11.4477 17 12L17 36C17 36.5523 17.4477 37 18 37H30C30.5523 37 31 36.5523 31 36C31 35.4477 30.5523 35 30 35H20C19.4477 35 19 34.5523 19 34L19 12C19 11.4477 18.5523 11 18 11Z\" fill=\"#333333\"/>\n\n"},
	toString: function(){ return this.url;}
})